import Vuex from 'vuex'

const state = () => ({
  headerSearchOpen: false,
  modal: null
})

const EllevioStoreWeb = new Vuex.Store({
  state,
  actions: {
    modalOpen(context, payload) {
      context.commit('updateModalType', payload)
    },
    toggleHeaderSearch(context) {
      context.commit('updateHeaderSearch')
    }
  },
  mutations: {
    updateModalType(state, payload) {
      state.modal = payload
    },
    updateHeaderSearch(state) {
      state.headerSearchOpen = !state.headerSearchOpen
    }
  }
})

export default EllevioStoreWeb
